import React from 'react'
import styled from 'styled-components'

const Styled = styled(({ tagName: TagName = 'p', ...rest }) => (
  <TagName {...rest} />
))`
  display: block;
`

export default Styled
